import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso3pagePage } from './paso3page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso3pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso3pagePageRoutingModule {}
